// ------------------------------------
// props 輸入需求 :
// props.hide : function( void )                    ( 開關按鈕 )
// props.data : object : { data: array }            (  )
// props.toggleRefresh : function( void )                 ( 重整 )
// ------------------------------------


import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import ResidentArrPad from './ResidentArrPad';
import '../../user/Assign/_assign.scss'
import ApiGo from '../../../actions/ApiGo';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_BEDS_ARRAY } from '../../../stores/reducer_beds';
import { ADD_RESIDENTS_ARRAY } from '../../../stores/reducer_residentsArray';
import Mos from '../../../actions/Mos';


// ── 色票常數，方便日後集中修改 ──────────────────────────
// COLOR_LABEL: 不另外指定，讓標籤與 X 按鈕同樣繼承 assign_layout CSS class 的黃色
const COLOR_VALUE = '#fff0f3';   // 原本的標籤色（粉）→ 現在給值
const FONT_WEIGHT = 600;          // 全域統一字重
// ───────────────────────────────────────────────────────


const AssignResidentPad = (props) => {
    const mos = Mos()
    let pad = props.data
    let resident_name = (pad.first_name || pad.last_name) ? pad.first_name + " " + pad.last_name : ""

    const [selectionEff, setSelectionEff] = useState(false);
    const [t] = useTranslation()
    const [selectedResidnet, setSelectedResidnet] = useState([resident_name, pad.resident_id]);
    const [firstTime, setFirstTime] = useState(true);
    const [bed_arr, setBed_arr] = useState([]);

    const dispatch = useDispatch()

    const [UpdateRedux, setUpdateRedux] = useState(false);
    useEffect(() => {
        if (UpdateRedux) {
            ApiGo.getBed().then(res => { dispatch(ADD_BEDS_ARRAY(res.beds)) })
            ApiGo.getResidents().then(res => { dispatch(ADD_RESIDENTS_ARRAY(res)) })
            props.hide()
        }
    }, [UpdateRedux, dispatch, props]);

    const store_residents_array = useSelector(state => state.store_residents.orign_residents_array)
    useEffect(() => {
        if (firstTime) {
            let _arr = [];
            store_residents_array.forEach((res) => {
                if (res.mac === null || res.mac === undefined || res.mac === "") {
                    _arr.push({ name: res.first_name + " " + res.last_name, id: res.id, selected: null })
                }
                if (res.mac === pad.mac) {
                    _arr.push({ name: res.first_name + " " + res.last_name, id: res.id, selected: "add" })
                }
            })
            setBed_arr(_arr)
        }
        setFirstTime(false)
    }, [firstTime, store_residents_array, pad.mac])

    function removeFromSelected(res) {
        let _arr = bed_arr
        let _previous_selection = undefined
        bed_arr.forEach((bed, index) => { if (bed.selected === "add") { _previous_selection = index } })
        _arr[res].selected = "add"
        if (_previous_selection !== undefined) { _arr[_previous_selection].selected = "remove" }
        setBed_arr(_arr)
    }

    function removeAndMatch_pad() {
        deleteSmartPad().then(() => {
            matchSmartPad().then((res) => { console.log(res); setUpdateRedux(true) })
                .catch(err => { console.log(err); })
        }).catch(err => {
            matchSmartPad().then((res) => { console.log(res); setUpdateRedux(true) })
                .catch(err => { console.log(err); })
        })
        mos.sendPayload('line_notify/resetResident', 'reset')
    }
    function deleteSmartPad() {
        return new Promise((resolve, reject) => {
            if (pad.mac === null) {
                resolve("no mac to remove")
            } else {
                ApiGo.deleteSmart_pad(pad.mac)
                    .then(res => { resolve(res) })
                    .catch(err => { resolve(err) })
            }
        })
    }
    function matchSmartPad() {
        return new Promise((resolve, reject) => {
            ApiGo.postMatching_smart_pad(pad.mac, (pad.id === null) ? "" : pad.id, (pad.resident_id === null) ? "" : pad.resident_id, selectedResidnet[1])
                .then(res => { resolve(res) })
                .catch(err => { reject(err) })
        })
    }


    // ── 共用 inline-style ─────────────────────────────────
    const labelStyle = (extraWidth) => ({
        flexShrink: 0,
        width: extraWidth,
        // backgroundColor 不指定 → 繼承 assign_layout CSS class 黃色，與 X 按鈕一致
        fontWeight: FONT_WEIGHT,
    });
    const valueStyle = (extraWidth, extra = {}) => ({
        flexShrink: 0,
        width: extraWidth,
        backgroundColor: COLOR_VALUE,   // 粉色 → 值
        fontWeight: FONT_WEIGHT,
        fontSize: '1.5rem',
        wordBreak: 'break-all',
        padding: '0 8px',
        ...extra,
    });
    const btnStyle = {
        backgroundColor: COLOR_VALUE,   // 粉色 → 按鈕
        fontWeight: FONT_WEIGHT,
    };
    // ─────────────────────────────────────────────────────


    return (
        <div onClick={props.hide} className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-black">
            <div className='fx-d-c fx-ncfs h-80 w-80'>

                {/* ── 頂部資訊列 ─────────────────────────────────── */}
                <div
                    className='w-100 h-20 assign_frame'
                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'stretch', justifyContent: 'flex-start' }}
                >
                    {/* 群組 1：單位 */}
                    <div
                        className="h-100 assign_layout font-xl fx-d-c fx-ccc"
                        onClick={e => e.stopPropagation()}
                        style={labelStyle('15%')}
                    >
                        {t("GLOBAL.INSTITUTION")}
                    </div>
                    <div
                        className="h-100 assign_layout fx-ccc"
                        onClick={e => e.stopPropagation()}
                        style={valueStyle('15%')}
                    >
                        {pad.institution ?? '-'}
                    </div>

                    {/* 群組間距 */}
                    <div style={{ flexShrink: 0, width: '1.5%' }} />

                    {/* 群組 2：編號 */}
                    <div
                        className="h-100 assign_layout font-xl fx-d-c fx-ccc"
                        onClick={e => e.stopPropagation()}
                        style={labelStyle('10%')}
                    >
                        {t("NAV_BAR.NUMBER")}
                    </div>
                    <div
                        className="h-100 assign_layout fx-ccc"
                        onClick={e => e.stopPropagation()}
                        style={valueStyle('10%')}
                    >
                        {pad.padNumber ?? '-'}
                    </div>

                    {/* 群組間距 */}
                    <div style={{ flexShrink: 0, width: '1.5%' }} />

                    {/* 群組 3：智慧墊 */}
                    <div
                        className="h-100 assign_layout font-xl fx-d-c fx-ccc"
                        onClick={e => e.stopPropagation()}
                        style={{ ...labelStyle('13%'), whiteSpace: 'nowrap' }}
                    >
                        {t("NAV_BAR.PADS")}
                    </div>
                    <div
                        className="h-100 assign_layout fx-ccc"
                        onClick={e => e.stopPropagation()}
                        style={valueStyle('22%')}
                    >
                        {pad.mac}
                    </div>

                    {/* X 按鈕：維持原色 */}
                    <div style={{ marginLeft: 'auto' }} className='forCrossframe'>
                        <div className='box cross light fx-ccc assign_layout' style={{ width: '60px', height: '60px' }} />
                    </div>
                </div>
                {/* ── 頂部資訊列 end ──────────────────────────────── */}


                {/* ── 可使用 ─────────────────────────────────────── */}
                <div className="w-100 h-40 assign_frame fx-d-r" onClick={e => e.stopPropagation()}>
                    <div
                        className='w-20 pad-45 l r h-100 assign_layout font-xl fx-d-c fx-ccc'
                        style={{ fontWeight: FONT_WEIGHT }}
                    >
                        {t("USERS.AVALIABLE")}
                    </div>
                    {/* 值區：粉色底，字體大小與編號值一致 (1.5rem) */}
                    <div
                        className='w-80 h-100 assign_layout fx-d-r flex-wrap ovy-a'
                        style={{ backgroundColor: COLOR_VALUE, fontSize: '1.5rem', fontWeight: FONT_WEIGHT }}>
                        {
                            bed_arr.map((bed, index) => {
                                return (
                                    <ResidentArrPad
                                        type={bed.selected}
                                        remove={removeFromSelected}
                                        setSelectedResidnet={setSelectedResidnet}
                                        setSelectionEff={setSelectionEff}
                                        selectionEff={selectionEff}
                                        key={index}
                                        index={index}
                                        res={bed} />
                                )
                            })
                        }
                    </div>
                </div>
                {/* ── 可使用 end ──────────────────────────────────── */}


                {/* ── 已選擇 ─────────────────────────────────────── */}
                <div className="w-100 h-20 assign_frame fx-d-r">
                    <div
                        className='w-20 h-100 pad-45 l r assign_layout font-xl fx-d-c fx-ccc'
                        onClick={e => e.stopPropagation()}
                        style={{ fontWeight: FONT_WEIGHT }}   // 黃色來自 CSS class
                    >
                        {t("USERS.SELECTED")}
                    </div>
                    <div
                        className='w-60 h-100 assign_layout fx-d-r fx-ccc font-exlarge'
                        onClick={e => e.stopPropagation()}
                        style={{ backgroundColor: COLOR_VALUE, fontWeight: FONT_WEIGHT }}  // 粉色值
                    >
                        {selectedResidnet[0]}
                    </div>
                    <div className='w-20 h-100 fx-d-c fx-csbc align-items-end' onClick={e => e.stopPropagation()}>
                        {/* 確認：粉色 */}
                        <div
                            className='assign_layout _btn font-xxl fx-ccc'
                            style={btnStyle}
                            onClick={() => { removeAndMatch_pad() }}
                        >
                            {t("GLOBAL.CONFIRM")}
                        </div>
                        {/* 取消：粉色 */}
                        <div
                            className='assign_layout _btn font-xxl fx-ccc'
                            style={btnStyle}
                            onClick={props.hide}
                        >
                            {t("GLOBAL.CANCEL")}
                        </div>
                    </div>
                </div>
                {/* ── 已選擇 end ──────────────────────────────────── */}

            </div>
        </div>
    );

}
export default AssignResidentPad;